<template>
    <div class="reviews">
        <b-row>
            <b-col md="6" offset-md="3" class="">
                <h1>{{ msg }}</h1>
                <p class="mt-4 mb-4">
                    This is an experimental wine review generator that creates new reviews from a wine's attributes.
                </p>
                <b-form @submit="onSubmit" v-if="true" class="text-left border-muted border rounded p-3">

                    <b-form-group id="input-group-winetype" label="Wine Type:" label-for="input-winetype"
                                  label-cols="2">
                        <b-form-select
                                id="input-winetype"
                                v-model="form.wine_type"
                                :options="wine_types"
                                required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-region" label="Region:" label-for="input-with-region" label-cols="2">
                        <b-form-input list="region-list" v-model="form.selected_region"
                                      id="input-with-region" placeholder="Select the wine region"></b-form-input>
                        <b-form-datalist id="region-list" :options="attr_vals.regions"></b-form-datalist>

                    </b-form-group>


                    <b-row class="mt-5 pb-3">
                        <b-col md="2">
                            Rating
                        </b-col>
                        <b-col>
                            <vue-slider v-model="form.rating" :min="80" :max:="100" :interval="1"
                                        :contained="1" :lazy=true :tooltip-formatter="'{value} points'"
                                        :tooltip="'always'"></vue-slider>
                        </b-col>
                    </b-row>


                    <b-row class="mb-2 mt-3">
                        <b-col md="2">
                            Price
                        </b-col>
                        <b-col>
                            <vue-slider v-model="form.price" :min="10" :max:="100" :interval="5"
                                        :contained="1" :lazy=true :tooltip-formatter="'${value}'"
                                        :tooltip="'always'"></vue-slider>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3 mb-4">
                        <b-col md="2" class="pt-1">
                            Varietals
                        </b-col>
                        <b-col>
                            <vue-tags-input
                                    v-model="form.varietal"
                                    :tags="form.selected_varietals"
                                    placeholder="Select varietals"
                                    @tags-changed="newTags => form.selected_varietals = newTags"
                                    :autocomplete-items="filteredVarietals"
                                    typeahead="true"
                                    typeahead-max-results="7"
                                    :only-existing-tags="1"
                                    typeahead-style="badges"
                                    style="width:100%;"
                                    class=""
                            />
                        </b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col md="2" class="pt-1">
                            Features
                        </b-col>
                        <b-col>
                            <vue-tags-input
                                    v-model="form.characteristic"
                                    :tags="form.selected_characteristics"
                                    @tags-changed="newTags => form.selected_characteristics = newTags"
                                    placeholder="Select flavors and other characteristics"
                                    :autocomplete-items="filteredCharacteristics"
                                    style="width:100%;"
                                    class=""
                            />
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col class="text-center">
                            <b-button style="text-center; background: rgb(64,82,166);" type="submit">Create review</b-button>
                        </b-col>
                    </b-row>
                </b-form>

                <div class="mt-5">
                        <b-card
                                :header="form.points"
                                header-tag="header"
                                title="Wine Review"
                        >
                            <div v-if="is_generating">
                                <b-spinner class="mt-1 mb-2"></b-spinner>
                                <b-card-text >Generating review (takes around 15 seconds)</b-card-text>
                            </div>
                            <b-card-text class="h6" v-if="!is_generating && review_text">"{{ review_text }}"</b-card-text>
                        </b-card>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
        components: {
            VueTagsInput,
        },
        name: 'Reviews',
        props: {
            msg: String
        },
        data() {
            return {
                is_generating: false,
                review_text: null,
                form: {
                    wine_type: 'Red',
                    rating: 90,
                    price: 20,
                    selected_region: '',
                    varietal: '',
                    selected_varietals: [],
                    characteristic: '',
                    selected_characteristics: []
                },
                attr_vals: {regions: [], varietals: [], characteristics: []},
                wine_types: ['Red', 'White', 'Sparkling', 'Rose', 'Dessert']
            }
        },
        computed: {
            filteredVarietals() {
                return this.attr_vals.varietals.filter(i => {
                    return i.text.toLowerCase().indexOf(this.form.varietal.toLowerCase()) !== -1;
                });
            },
            filteredCharacteristics() {
                return this.attr_vals.characteristics.filter(i => {
                    return i.text.toLowerCase().indexOf(this.form.characteristic.toLowerCase()) !== -1;
                });
            },
        },
        methods: {
            onSubmit(evt) {
                const vm = this
                // eslint-disable-next-line no-console
                evt.preventDefault()
                vm.is_generating = true
                // Executing generator
                const url = process.env.VUE_APP_GENERATOR_URL
                const body = {
                    regions: [vm.form.selected_region],
                    varietals: vm.form.selected_varietals.map(a => a.text),
                    characteristics: vm.form.selected_characteristics.map(a => a.text),
                    rating: vm.form.rating,
                    price: vm.form.price,
                    wine_type: vm.form.wine_type
                }
                // eslint-disable-next-line no-console
                // console.log(/"body:", body)
                vm.axios.post(url, body).then((response) => {
                    // eslint-disable-next-line no-console
                    //console.log(response.data)
                    vm.review_text = response.data.results
                    vm.is_generating = false
                })
            }
        },
        mounted() {
            const vm = this
            // Load attributes
            // eslint-disable-next-line no-console
            const url = process.env.VUE_APP_METADATA_URL
            // eslint-disable-next-line no-console
            vm.axios.post(url, {attributes: ['regions', 'varietals', 'characteristics']}).then((response) => {
                // eslint-disable-next-line no-console
                // console.log(response.data)
                vm.attr_vals.regions = response.data.results.regions
                vm.attr_vals.varietals = []
                for (let varietal of response.data.results.varietals) {
                    vm.attr_vals.varietals.push({text: varietal})
                }
                vm.attr_vals.characteristics = []
                for (let characteristic of response.data.results.characteristics) {
                    vm.attr_vals.characteristics.push({text: characteristic})
                }
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">

    .vue-tags-input .ti-tag {
        position: relative;
        background: #ebde6e;
        color: #283944;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>

